module.exports = __webpack_public_path__ + "static/media/sky.5aa787a6.jpg";